<template>
  <div class="helpful-actions-cell-wrapper" @click="$emit('click')">
    <div class="top-section">
      <div style="margin-right: 16px"><img :src="getIconURL" style="height: 48px; width: 48px" /></div>
      <div class="desc-styling">{{description}}</div>
    </div>
    <div class="link-text-styling">{{linkText}} ></div>
  </div>
</template>

<script>
export default {
  name: 'ShortcutCellWithoutBorder',
  props: {
    icon: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    linkText: {
      type: String,
      default: ''
    }
  },
  computed: {
    getIconURL () {
      return require(`../statics/icons/${this.icon}.svg`)
    }
  }
}
</script>

<style scoped>
.helpful-actions-cell-wrapper {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #E5E6EE;
  padding-bottom: 24px;
  font-size: 16px;
  margin-bottom: 24px;
  cursor: pointer;
}

.helpful-actions-cell-wrapper:hover{
  background-color: white
}

.top-section {
  display: flex;
  align-items: center;
}

.desc-styling {
  width: 318px;
  line-height: 24px;
  font-weight: 400;
}

.link-text-styling {
  color: #128279;
  margin-top: 8px;
  margin-left: 64px;
}
.link-text-styling:hover {
  text-decoration: underline;
}

</style>
